import { User } from 'entities';
import { createContext, useContext } from 'react';

interface TeamContextData {
  teamUsers: User[];
  loadingUsers: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const teamCtx = createContext<TeamContextData>(null as any);

export function useTeam(): TeamContextData {
  const context = useContext(teamCtx);

  if (!context) {
    throw new Error('useTeam must be used within its Provider');
  }

  return context;
}
